import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
   

    resources: {
      en: {
        translation: {
          selectedbrand: {
            heading1: 'Selected Brands',
            heading2: 'Importing frozen products from more than 2 of the biggest and most reliable food companies with the best qualities all around the world.'
          },

          
          importing: {
            heading1: 'Importing products from',
            heading2: 'Siraj alnojoom Company has more than 2 years of experience importing products around the world such...',
            title: 'Where do we import our products from? '
          },

          navbarTxt: {
            home: 'Home',
            about: 'About',
            contact: 'Contact',
            service: 'Service',
            products: 'Products',
            brands: 'Brands',
            events: 'Events',
            career: 'Career',
            language: 'Language',
          },

          career: {
            heading1: 'Siraj alnojoom Company Careers',
            heading2: "Join our team. We'd love to have more talented people on board. Check out our open positions!",
            title1: 'There are no careers available at this time...',
            title2: 'No Jobs Found!'
          },

          aboutus: {
            heading1: 'About us',
            heading2: 'Siraj alnojoom Company has a long history of importing foods all around the world to Iraq’s marketplace.',
            title1: 'Who are we ? ',
            content1: 'This company is a member of ( Chamber of Commerce & Industry) as a grade (First) in ministry of Commerce & Industry.',
            content2: 'The beginning of this company goes back to 2025 with importing the best quality of foods from outside.',
            mission: 'Our Mission',
            missiontitle: 'Our mission is to provide the highest quality and healthiest food products to our country, to bring the best of the world into each home within Iraq.',
            vission: 'Our Vision',
            vissiontitle: 'We long for people’s satisfaction and give them the access to taste delicious foods from outside of country that will leave a lasting impression.'
          },
          brands: {
            heading1: 'Brands',
            heading2: 'We are growing...and hiring. Come join us!'
          },
          events: {
            heading1: 'Events',
            heading2: 'We are growing...and hiring. Come join us!',
            link: 'Link',


            gullfood: {
              heading1: 'Gulfood',
              title: 'Established over 25 years, gulfood has a well-deserved reputation for the Middle East, Africa, and south Asia. Gulfood provides a trade and sourcing platform without equal, where international flavors find world-class business.',
              date_one: 'Feb 19, 2024 ',
              date_two: 'Feb 23, 2024  ',
            },
            sailparis: {
              heading1: 'SIAL Paris',
              title: 'For over 50 years, sial Paris has been welcoming a melting pot of industry players to the French capital to share their savoir-faire and create the recipes of the future. The first edition was held during international food week in 1964, and united experts and enthusiasts from 26 countries. Today, the biennial attracts exhibitors and visitors from over 200 countries and is a flagship event in the worldwide food calendar.',
              date_one: 'Oct 19, 2024',
              date_two: 'Oct 23, 2024',
            },
            amricanfood: {
              heading1: 'Americas Food and Beverage Show & Conference',
              title: 'Americas food and beverage show & conference has a well-deserved reputation for the north, central and south America markets, providing a trade and sourcing platform for the food and beverage industry, where international companies find world-class business.'

              , date_one: 'Sep 16, 2024 ',
              date_two: 'Sep 18, 2024',



            },
            Anuga: {
              heading1: 'Anuga',
              title: "Anuga is the world's largest and most important food and beverage fair - for new markets and target groups, for all the trends and themes and, above all, for first-rate contacts and business deals."
              , date_one: 'Oct 04, 2025 ',
              date_two: 'Oct 08, 2025',
            }
          },

          contact: {
            heading1: 'Get in touch',
            heading2: 'Get in touch and contact us',
            number: '07762717070',
            email: 'Alnojoom@siraj-alnojoom.comm',
            location: 'Sulaymaniyah, Iraq'

          },

          service: {
            heading1: 'Our Services',
            heading2: 'What are our services ?_',
            title1: 'Siraj alnojoom company is a trading company in which specializes in importing high quality frozen foods such as ( meat, eggs, chicken and its products) from international companies abroad E.g.(Turkey , India ,Paraguay , Brazil ,USA).',
            title2: 'The imported meat/chicken have been slaughtered according to the Islamic rites and is suitable for consumption by Muslims all around the world.'

          },


          homePage: {
            heading1: 'Siraj alnojoom',
            heading2: 'Company',
            title: 'WE BRING THE BEST INTO YOUR HOME.',
            content: 'Siraj alnojoom company has a long history of importing foods all around the world to Iraq’s marketplace.',
            button: 'About us',

            product: {
              readmore: 'ReadMore'
            }
          },

          category: {
            all: 'All',
            Chicken: 'Chicken',
            meat: 'Meat',
            meatlamb: 'Meat Lamb',
            meatbuffalo: 'Meat buffalo',
            fish: 'Fish',
          },

          footer: {
            heading1: 'Siraj alnojoom Company',
            title: 'For further information regarding our services and products please feel free to contact us.',
            bottom: 'Siraj alnojoom Company | All rights reserved.'
          },

          products: {
            heading1: 'Our Products',
            title: 'Wide range of frozen, and chilled products, and they are being kept in a stable ambient temperature.',
            chickendetail: 'Chicken (whole chicken, chicken breast, Chicken Griller, wings, drumstick, chicken leg quarters, shawarma, chicken products, etc...',
            meatdetail: 'Meat (Beef, mutton/lamb cut, Buffalo)',
            fishdetail: 'Fish (whole fish, fillet, fish steak, grilled fish, fish nuggets, fish fingers, smoked fish, sushi, canned fish, fish roe, fish products, etc.)',
            buttonseeproduct: 'See All Products',

            chicken1: 'Frozen chicken Leg bone-in skinless',
            chicken2: 'Frozen Chicken Drumsticks',
            chicken3: 'Frozen Chicken Wings',
            chicken4: 'Frozen Chicken Leg Quarter',
            chicken5: 'Frozen Chicken Breast Bone-in Skin-on',
            chicken6: 'Frozen Chicken Leg Boneless Skin-on',
            chicken7: 'Frozen Whole Chicken Griller',
            chicken8: 'Frozen Chicken Leg Bone-in Skin-on',
            chicken9: 'Frozen Chicken Breast',
            chicken10: 'Frozen Chicken Shawarma',

            meat1: 'Meat Beef Brisket',
            meat2: 'Meat Beef Top Sirloin',
            meat3: 'Whole beef Tenderloin',
            meat4: 'Meat Beef Ribeye (Bone-in)',
            meat5: 'Meat Beef Ribeye (Boneless)',
            meat6: 'Meat Beef Flank Steak',
            meat7: 'Meat Beef Short Ribs (Boneless)',
            meat8: 'Meat Beef Short Ribs (Bone-in)',
            meat9: 'Meat Beef Chuck Roast',
            meat10: 'Meat Beef Shanks (Shins)',
            meat11: 'Meat Beef Brisket, First cut, Trimmed',
            meat12: 'Meat Beef Eye round',

            lamb1: 'Lamb',
            lamb2: 'Lamb Leg',
            lamb3: 'Frozen Bone-in Lamb Cut Shoulder',
            lamb4: 'Frozen Lamb Shank',
            lamb5: 'Frozen Lamb Trim',
            lamb6: 'Frozen Lamb Chump Steaks',
            lamb7: 'Frozen Lamb Rack',
            lamb8: 'Lamb Rump Square Cut',

            meatbuffalo: 'Meat buffalo'

          }

        },
      },

      ar: {
        translation: {
          selectedbrand: {
            heading1: 'ماركات المختارة',
            heading2: 'استيراد المنتجات المجمدة من أكثر من 2من أكبر شركات الأغذية وأكثرها موثوقية وبأفضل الجودة في جميع أنحاء العالم.'
          },
          importing: {
            heading1: 'استراد المنتجات من',
            heading2: 'تتمتع شركة سیراج ئەل نجوم بخبرة تزيد عن 2عامًا في استيراد المنتجات حول العالم مثل...',
            title: 'من أين نستورد منتجاتنا؟'
          },
          footer: {
            heading1: 'شركة سیراج ئەل نجوم ',
            title: 'لمزيد من المعلومات حول خدماتنا ومنتجاتنا فلا تتردد في الاتصال بنا.',
            bottom: 'شركة سیراج ئەل نجوم | كل الحقوق محفوظة'

          },

          category: {
            all: 'الکل',
            Chicken: 'الدجاج',
            meat: 'اللحم',
            meatlamb: 'لحم خروف',
            meatbuffalo: 'لحم جاموس',
            fish: 'سمک',
          },

          career: {
            heading1: 'وظيفات شركة سیراج ئەل نجوم',
            heading2: "انضم الى فريقنا. نحن نود ان يكون لدينا المزيد من الاشخاص  الموهوبين. تحقق من الوظيفات الواردة لدينا!",
            title1: 'لا يوجد اي وظيفة متاحة في الوقت الحالي...',
            title2: 'لم يتم العثور على وظائف!'
          },

          events: {
            heading1: 'المناسبات',
            heading2: 'نحن نتقدم، و  نوظف. انضم الينا! ',
            link: 'وصلة',

            gullfood: {
              heading1: 'Gulfood',
              title: 'تأسست جلفود منذ أكثر من 25 عامًا، وتتمتع بسمعة مستحقة في منطقة الشرق الأوسط وأفريقيا وجنوب آسيا. يوفر جلفود منصة للتجارة والتوريد لا مثيل لها، حيث تجد النكهات الدولية أعمالاً على مستوى العالمية.',
              date_one: '١٩ فبرایر ٢٠٢٤',
              date_two: '٢٣ فبرایر ٢٠٢٤ ',
            },
            sailparis: {
              heading1: 'SIAL Paris',
              title: 'منذ أكثر من 50 عامًا، ظلت سيال باريس ترحب بمجموعة من الاشخاص في الصناعة في العاصمة الفرنسية لمشاركة خبرتهم وابتكار وصفات المستقبل. أقيمت النسخة الأولى خلال أسبوع الغذاء العالمي عام 1964، وجمعت خبراء ومتحمسين من 26 دولة. واليوم، يستقطب البينالي عارضين وزوارًا من أكثر من 200 دولة ويعتبر حدثًا رئيسيًا في تقويم الأغذية العالمي.',
              date_one: '١٩ اوکتوبر ٢٠٢٤ ',
              date_two: '٢٣ اوکتوبر ٢٠٢٤',

            },
            amricanfood: {
              heading1: 'Americas Food and Beverage Show & Conference',
              title: 'يتمتع معرض ومؤتمر الأطعمة والمشروبات في الأمريكا بسمعة تستحقها عن جدارة في أسواق أمريكا الشمالية والوسطى والجنوبية، حيث يوفر منصة تجارية ومصادر لصناعة الأغذية والمشروبات، حيث تجد الشركات العالمية أعمالًا ذات مستوى عالمي.',
              date_one: '١٦ سبتمبر ٢٠٢٤',
              date_two: ' ١٨ سبتمبر ٢٠٢٤',

            },
            Anuga: {
              heading1: 'Anuga',
              title: "أنوجا هو أكبر وأهم معرض للأغذية والمشروبات في العالم - للأسواق الجديدة والمجموعات المستهدفة، لجميع الاتجاهات والموضوعات، وقبل كل شيء، للاتصالات والصفقات التجارية من الدرجة الأولى.",
              date_one: '٤ اوکتوبر ٢٠٢٥',
              date_two: '٨ اوکتوبر ٢٠٢٥',

            }
          },

          brands: {
            heading1: 'العلامات التجارية',
            heading2: 'نحن نتقدم، و  نوظف. انضم الينا!'
          },

          aboutus: {
            heading1: 'معلومات عنا',
            heading2: 'شركة سیراج ئەل نجوم لديها تأريخ طويل في استراد الأغذية حول العالم الى سوق العراق.',
            title1: 'من نحن؟',
            content1: 'هذه الشركة عضو في (غرفة التجارة و الصناعة) تأتي بالصف (الأول) في وزارة التجارة و الصناعة.',
            content2: 'بداية هذه الشركة يعود لعام (٢٠٢٥) مع استراد أفضل جودة من الأغذية بالخارج.',
            mission: 'هدفنا',
            missiontitle: 'هدفنا هو توفير اعلى جودة و أصح منتج لبلدنا، لجلب الأفضل من العام الى كل منزل بالعراق.',
            vission: 'رؤيتنا',
            vissiontitle: 'نحن نسعى لرضى الناس و نمنحهم الإمكانية لتذوق أطعمة لذيذة من خارج البلاد التي ستترك انطباعا دائميا.'
          },

          contact: {
            heading1: 'تواصل معنا',
            heading2: 'تواصل معنا',
            number: '07762717070',
            email: 'Alnojoom@siraj-alnojoom.com',
            location: 'السليمانية، العراق'

          },

          service: {
            heading1: 'الخدمات لدينا',
            heading2: 'ما هو خدماتنا؟_',
            title1: 'شركة سیراج ئەل نجوم هي شركة تجارية التي مختصة في استراد اعلى جودة من الأغذية المجمدة ك( لحم، بيض، دجاج و منتجاتها) من الشركات الدولية بالخارج، كالمثل ( تركيا،  برازيل، باراكواي، الولايات المتحدة الامريكية، هندستان).',
            title2: 'لقد تم اللحم/ الدجاج المستردة بالذبح على الطريقة الاسلامية و يناسب الاستهلاك من قبل المسلمون من جميع انحاء العالم.'

          },

          products: {

            heading1: 'منتجاتنا',
            title: 'مجموعة واسعة من المنتجات المجمدة والمبردة، ويتم حفظها في درجة حرارة محيطة ثابتة.',
            chickendetail: 'الدجاج ( صدر دجاج دجاجة كاملة ، أجنحة، أفخاذ دجاج، أرباع فخذ دجاج، شاورما، منتجات دجاج إلخ...',
            meatdetail: 'اللحوم (لحم البقر، لحم الضأن/قطع خروف ، الجاموس)',
            fishdetail: 'الأسماك (سمكة كاملة، فيليه، شريحة سمک، سمك مشوي، ناجتس السمك، أصابع السمك، سمك مدخن، سوشي، سمك معلب، بطارخ سمك، منتجات سمكية، إلخ.)',
            buttonseeproduct: 'رؤية جميع المنتجات',

            chicken1: 'أرجل دجاج معظم و بدون جلد مجمدة',
            chicken2: 'سيقان دجاج مجمدة',
            chicken3: 'أجنحة دجاج مجمدة',
            chicken4: 'ربع فخذ الدجاج قصاع دجاج مجمدة',
            chicken5: 'صدر محامل مع عظيم مع الجلد',
            chicken6: 'فخذ دجاج كامل مجمد بدون عظم و مع الجلد',
            chicken7: 'دجاج كامل مجمدة',
            chicken8: 'فخذ دجاج مجمدة مع عظام و مع الجلد',
            chicken9: 'صدر دحاج مجمدة',
            chicken10: 'شاورما دجاج مجمدة',

            meat1: 'صدر واحد من اللحم البقري',
            meat2: 'قطعة من اللحم الأحمر',
            meat3: 'عرق الفلتو كامل',
            meat4: 'شطيرة اللحم مع العظم',
            meat5: 'شطيرة اللحم بدون عظم',
            meat6: 'شريحة لحم البقر',
            meat7: 'لحم البقر الضلوع الصغيرة ( بدون عظم )',
            meat8: 'لحم البقر الضلوع الصغيرة ( مع عظم )',
            meat9: 'لحم البقر تشاك المشوي',
            meat10: 'عرقوب لحم البقري',
            meat11: 'لحم صدر البقر، قطع الأول، مشذبة',
            meat12: 'لحم بقر عين مستديرة',

            lamb1: 'لحم خروف',
            lamb2: 'فخذ الخروف',
            lamb3: 'لحم كتف الخروف مجمد',
            lamb4: 'عرقوب خروف مجمد',
            lamb5: 'تقليم لحم الخروف مجمد',
            lamb6: 'شرائح لحم الضأن المجمدة',
            lamb7: 'رف لحم الضأن المجمد',
            lamb8: 'ردف خروف مقطع بالمربعات',

            meatbuffalo: 'لحم جاموس'


          },
          navbarTxt: {
            home: 'الرئيسية',
            about: 'حول',
            contact: 'اتصل',
            service: 'الخدمات',
            products: 'منتجات',
            brands: 'العلامات التجارية',
            events: 'الأحداث',
            career: 'وظيفات',
            language: 'اللغة',

          },
          homePage: {
            heading1: 'سیراج ئەل نجوم',
            heading2: 'شریکة',
            title: 'نحن نجلب الأفضل الى منزلكم.',
            content:
              'شركة سیراج ئەل نجوم لديها تأريخ طويل في استراد الأغذية حول العالم الى سوق العراق.',
            button: 'معلومات عنا',
            product: {
              readmore: 'اقرأ المزيد'
            }
          }

        },
      },

      kr: {
        translation: {

          selectedbrand: {
            heading1: 'براندە هەڵبژێردراوەکان',
            heading2: 'هاوردەکردنی بەرهەمی بەستوو لە زیاتر لە 2 گەورەترین و متمانەپێکراوترین کۆمپانیای خۆراک بە باشترین کوالیتی لە سەرانسەری جیهان.'
          },

          importing: {
            heading1: 'هاوردەکردنی بەرهەمەکان لە',
            heading2: 'کۆمپانیای سیراج ئەل نجوم ئەزموونی زیاتر لە 2 ساڵی هەیە لە هاوردەکردنی بەرهەم لە سەرانسەری جیهاندا وەک...',
            title: 'بەرهەمەکانمان لەکوێوە هاوردە دەکەین؟ '
          },
          footer: {
            heading1: 'کۆمپانیای سیراج ئەل نجوم',
            title: 'بۆ زانیاری زیاتر سەبارەت بە خزمەتگوزاری و بەرهەمەکانمان تکایە پەیوەندیمان پێوە بکەن.',
            bottom: 'کۆمپانیای سیراج ئەل نجوم | هەموو مافەکانی پارێزراو '
          },

          category: {
            all: 'هەموو',
            Chicken: 'مریشک',
            meat: 'گۆشت',
            meatlamb: 'گۆشتی بەرخ',
            meatbuffalo: 'گۆشتی بوفاڵو',
            fish: 'ماسی',
          },

          career: {
            heading1: 'هەلی کارەکانی کۆمپانیای سیراج ئەل نجوم',
            heading2: "بەشداربە لەگەڵماندا. ئێمە دەمانەوێت کە کەسی بەهرەداری زیاترمان هەبێت لەگەڵمان کار بکات. سەردانی هەلی کارە بەردەستەکانمان بکە!",
            title1: 'لە ئێستادا هیچ هەلی کارێکی کراوە بەردەست نییە...',
            title2: 'هیچ هەلی کارێک نەدۆزرایەوە!'
          },

          events: {
            heading1: 'بۆنەکان',
            heading2: 'ئێمە پێشدەکەوین، وە هەلی کار دادەمەزرێنین. بەشداربە لەگەڵمان!',
            link: 'لینک',


            gullfood: {
              heading1: 'Gulfood',
              title: 'گاڵفوود زیاتر لە ٢٥ ساڵە دامەزراوە، وە ناوبانگێکی پڕ شایانی هەیە لە رۆژهەڵاتی ناوەڕاست و ئەفریقا و باشووری ئاسیا. گاڵفوود سەکۆیەکی بۆ بازرگانی و هاوردەکردن دابینکردووە کە وێنای نییە، کە تامە جیاوازە جیهانییەکان لەگەڵ ئاستێکی جیهانیدا یەکدەگرێتەوە.',
              date_one: '١٩ شوبات ٢٠٢٤',
              date_two: '٢٣ شوبات ٢٠٢٤',
            },
            sailparis: {
              heading1: 'SIAL Paris',
              title: 'زیاتر لە ٥٠ ساڵە، سیال پاریس بانگهێشتی کۆمەڵە کەسانێک دەکات لە بواری پیشەسازی لە پایتەختی فەڕەنسا بۆ بەشداریپێکردنی ئەزموون و لێهاتوویەکانیان بۆ بەرهەمهێنانی چێژ و تامی داهاتوو. یەکەمین خول لە ماوەی هەفتەی خۆراکی جیهانیدابوو لە ساڵی ١٩٦٤، وە هەستا بە کۆکردنەوەی لێهاتووەکان لە ٢٦ دەوڵەتەوە. وە ئەمڕۆ، ئەم بۆنەیە زیاتر لە ٢٠٠ دەوڵەتی جیاوازەوە گەشتیارلە خۆ دەگرێت و بە ڕووداوێکی سەرەکی دادەنرێت لە ڕۆژژمێری خۆراکی نێودەوڵەتی.',
              date_one: '١٩ تشرینی یەکەم ٢٠٢٤',
              date_two: '٢٣ تشرینی یەکەم ٢٠٢٤',

            },
            amricanfood: {
              heading1: 'Americas Food and Beverage Show & Conference',
              title: 'پێشانگا و کۆنفرانسی خۆراک و خواردنەوەکان لە ئەمریکا ناوبانگێکی پڕ شایانی هەیە لە بازاڕەکانی ئەمریکای باکوور و ناوەڕاست و باشوور، کە سەکۆیەکی بازرگانی و سەرچاوەی پیشەسازی و خۆراک و خواردنەوە دابین دەکات، کە کۆمپانیا جیهانییەکان کار دەدۆزنەوە لەسەر ئاستی جیهانی.',
              date_one: '١٦ ئەیلول ٢٠٢٤',
              date_two: ' ١٨ ئەیلول ٢٠٢٤',

            },
            Anuga: {
              heading1: 'Anuga',
              title: "ئانوگا گەورەترین و گرنگترین پێشانگای خۆراک و خواردنەوەیە لە جیهاندا – بۆ بازاڕە تازەکان و ئەوانەی کە کراونەتە ئامانج، بۆ هەموو بابەتەکان ئاڕآستەکان، وە بەر لە هەموو شتێک، بۆ پەیوەندییەکان و ڕێککەوتنە بازرانییەکان لە پلەی یەکەمدا.",
              date_one: '٤ تشرینی یەکەم ٢٠٢٥',
              date_two: '٨ تشرینی یەکەم ٢٠٢٥',
            }
          },



          aboutus: {
            heading1: 'دەربارەی ئێمە',
            heading2: 'کۆمپانیای سیراج ئەل نجوم مێژوویەکی درێژی هەیە لە هاوردەکردنی خۆراک لە سەرانسەری دونیادا بۆ بازاڕەکانی عێراق.'
            , title1: 'ئێمە کێین؟',
            content1: 'ئەم کۆمپانیایە ئەندامێکە لە (ژووری بازرگانی و پیشەسازی) وەک پلەی (یەکەم) دێت لە وەزارەتی بازرگانی و پیشەسازی.',
            content2: 'سەرەتای ئەم کۆمپانیایە دەگەڕێتەوە بۆ ساڵی (٢٠٢٥) بە هاوردەکردنی باشترین خۆراک لە وڵاتانی دەرەوە.',
            mission: 'ئامانجی ئێمە ',
            missiontitle: 'ئامانجمان دابین کردنی تەندروستترین و بەرزترین کوالیتی خواردنە بۆ وڵاتەکەمان، وە بۆ هێنانەوەی باشترینە لە سەرانسەری جیهانەوە بۆ هەر ماڵێک لە عێراق.',
            vission: 'دیدگای ئێمە',
            vissiontitle: 'ئێمە دەگەڕێین بە دوای ڕەزامەندی خەڵک و توانای تامکردنی بەلەزەتترین خواردنیان پێ دەبەخشین کە لە دەرەوەی وڵاتەوە هاتووە، وە مۆرکێکی هەمیشەییان لەسەر بە جێ دەهێڵێت.'
          },

          brands: {
            heading1: 'براندە بازرگانییەکان',
            heading2: 'ئێمە پێشدەکەوین، وە هەلی کار دادەمەزرێنین. بەشداربە لەگەڵمان!'
          },

          service: {
            heading1: 'خزمەتگوزاریەکانمان',
            heading2: 'خزمەتگوزاریەکانمان چین؟_',
            title1: 'کۆمپانیای سیراج ئەل نجوم کۆمپانیایەکی بازرگانییە کە تایبەتمەندە بە هاوردەکردنی بەرزترین کوالیتی خواردنی بەستوو وەک (گۆشت، هێلکە، مریشک و بەرهەمەکانی) لە کۆمپانیا نێودەوڵەتییەکانی دەرەوە، بۆ نموونە (تورکیا، بەڕازیل، پاراگوای، ویلایەتە یەکگرتووەکانی ئەمریکا، هیندستان).',
            title2: 'گۆشت یان مریشکی هاوردەکراو بە ڕیکاری ئایینی ئیسلامی سەربڕدراوە و گونجاوە بۆ بەکارهاتنی لە لایەن موسوڵمانان لە سەرانسەری جیهاندا.'

          },

          contact: {
            heading1: 'پەیوەندیمان پێوە بکەن',
            heading2: 'پەیوەندیمان پێوە بکەن',
            number: '07762717070',
            email: 'Alnojoom@siraj-alnojoom.com',
            location: 'السليمانية، العراق'


          },

          products: {
            heading1: 'بەرهەمەکانمان',
            title: 'کۆمەڵێکی زۆر بەرهەمی مریشکی بەستوو و ساردکراوە، کە لە پلەیەکی گەرمی جێگیردا پارێزراون.',

            chickendetail: 'مریشک (سنگی مریشك، مریشکی تەواو، باڵ، سەرەڕانی مریشک، ڕانی مریشک، شاورمە، بەرهەمەکانی مریشک، هتد...)',
            meatdetail: 'گۆشت (گۆشتی مانگا، گۆشتی مەڕ/ پارچە گۆشتی بەرخ، گامێش)',
            fishdetail: 'ماسی (ماسی تەواو، فیلێت، ستەیکی ماسی، ماسی برژاو، نەگێتی ماسی، فینگەری ماسی، ماسی سمۆکی، سوشی، ماسی لە قوتووکراو، کۆترە ماسی، بەرهەمەکانی ماسی، هتد...)',
            buttonseeproduct: 'هەموو بەرهەمەکان ببینە',

            chicken1: 'ڕانی مریشکی بەستوو (بەئێسک و بێ ئێسک)',
            chicken2: 'سەرەڕانی مریشکی بەستوو',
            chicken3: 'باڵی مریشکی بەستوو',
            chicken4: 'ڕانی مریشکی بەستوو',
            chicken5:
              'سنگی مریشکی بەستوو (بەئێسک و بە پێست)'
            ,
            chicken6: 'ڕانی مریشکی بەستوو (بێ ئێسک و بە پێست)',
            chicken7: 'مریشکی کاملی بەستوو',
            chicken8: 'باڵی مریشکی بەستوو (بە ئێسک و بە پێست)',
            chicken9: 'سنگی مریشکی بەستوو',
            chicken10: 'شاورمەی مریشکی بەستوو',

            meat1: 'پارچە سنگی گۆشتی مانگا',
            meat2: 'پارچەی گۆشتی سوور',
            meat3: 'گۆشتی گەردەمل',
            meat4: 'ستەیکی گۆشت بە ئێسک',
            meat5: 'ستەیکی گۆشت بێ ئێسک',
            meat6: 'ستەیکی گۆشتی مانگا',
            meat7: 'پڕزۆڵە مانگای پارچە بچووک (بێ ئێسک )',
            meat8: 'پڕزۆڵە مانگای پارچە بچووک (بە ئێسک)',
            meat9: 'گۆشتی مانگای چاک',
            meat10: 'ماینچەی گۆشتی مانگا ',
            meat11: 'گۆشتی سنگی مانگا، یەک پارچە، حازرکراو',
            meat12: 'گۆشتی مانگای ئای ڕاوند',

            lamb1: 'گۆشتی بەرخ',
            lamb2: 'ڕانی بەرخ',
            lamb3: 'گۆشتی دەفەی شانی و بەرخی بەستوو',
            lamb4: 'ماینچەی بەرخی بەستوو',
            lamb5: 'گۆشتی بەرخی بەستووی پارچەپارچەکراو',
            lamb6: 'پارچە گۆشتی بەرخی بەستوو',
            lamb7: 'پەراسووی گۆشتی بەرخی بەستوو پارچەی گەورە',
            lamb8: ' کەفەڵی گۆشتی بەرخ پارچەکراو',

            meatbuffalo: 'گۆشتی گامێش'



          },
          navbarTxt: {
            home: 'سەرەکی',
            about: 'دەربارە',
            contact: 'پەیوەندی',
            service: 'خزمەتگوزاری',
            products: 'بەرهەمەکانمان',
            brands: 'براندە بازرگانییەکان',
            events: 'بۆنەکان',
            career: 'هەلی کار',
            language: 'زمانەکان',

          },
          homePage: {
            heading1: 'کۆمپانیای',
            heading2: 'سیراج ئەل نجوم',
            title: 'ئێمە باشترین دەهێنین بۆ ماڵەکانتان',
            content: 'کۆمپانیای سیراج ئەل نجوم مێژوویەکی درێژی هەیە لە هاوردەکردنی خۆراک لە سەرانسەری دونیادا بۆ بازاڕەکانی عێراق.',
            button: 'لەبارەی ئێمە',
            product: {
              readmore: 'زیاتر بزانە'
            }
          }

        },
      },
    },
    fallbackLng: 'en',
    lowerCaseLng:true,
    debug: true,

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
